/* eslint-disable @typescript-eslint/no-explicit-any */
import dayjs from "dayjs";
import { Space, Typography } from "antd";

interface VisitExtendedProps {
  type: "visit" | "drive";
  durationMinutes?: number; // Not used by FC for height, but useful for data
  driveTimeMinutes?: number;
  location?: string;
  nextVisitLocation?: string;
  backgroundColor?: string; // Custom colors defined here
  textColor?: string;
  borderColor?: string;
  workOrders?: string[]; // Array of work order titles
  homeIcon?: string; // URL for home icon
}

export default function RenderEventContent({ eventInfo }: any) {
  const event = eventInfo.event;
  const customProps = event.extendedProps as VisitExtendedProps;

  const isDriveEvent = customProps.type === "drive";
  let dateInFuture = false;

  let durationText = "";
  if (isDriveEvent) {
    if (customProps.driveTimeMinutes !== undefined) {
      const totalMinutes = customProps.driveTimeMinutes;
      const hours = Math.floor(totalMinutes / 60);
      const remainingMinutes = totalMinutes % 60;

      if (hours > 0 && remainingMinutes > 0) {
        durationText = `${hours}h ${remainingMinutes}m`;
      } else if (hours > 0) {
        durationText = `${hours}h`;
      } else if (remainingMinutes > 0) {
        durationText = `${remainingMinutes}m`;
      }
    }
  } else if (event.start && event.end) {
    const start = dayjs(event.start);
    const end = dayjs(event.end);

    dateInFuture = start.isAfter(dayjs());

    const totalMinutes = dayjs.duration(end.diff(start)).asMinutes();

    if (totalMinutes > 0) {
      const hours = Math.floor(totalMinutes / 60);
      const remainingMinutes = totalMinutes % 60;

      if (hours > 0 && remainingMinutes > 0) {
        durationText = `${hours}h ${remainingMinutes}m`;
      } else if (hours > 0) {
        durationText = `${hours}h`;
      } else {
        durationText = `${remainingMinutes}m`;
      }
    }
  }

  // console.log("event.title", event);

  return (
    <div
      className={
        isDriveEvent
          ? "driveEventContent"
          : dateInFuture
          ? "visitEventContent futureEventContent"
          : "visitEventContent"
      }
    >
      {isDriveEvent ? (
        <Space size={4}>
          {/* <CarOutlined /> */}
          <Typography.Text style={{ fontSize: "12px", color: "#424647" }}>
            {durationText} drive
          </Typography.Text>
        </Space>
      ) : (
        <>
          <div style={{ display: "flex", alignItems: "center" }}>
            {customProps.homeIcon && (
              <img
                src={customProps.homeIcon}
                alt="Home Icon"
                style={{ width: "14px", height: "14px", marginRight: "4px" }}
              />
            )}
            <Typography.Text
              strong
              style={{ color: "inherit", lineHeight: 1.2, fontSize: "90%" }}
            >
              {event.title}
            </Typography.Text>
          </div>
          {customProps?.workOrders && customProps.workOrders.length > 0 && (
            <ul
              className="workOrdersList"
              style={{ paddingLeft: "20px", marginTop: "2px" }}
            >
              {customProps.workOrders.map((workOrder, index) => (
                <li
                  key={index}
                  style={{
                    color: "#151718",
                    fontSize: "12px",
                    listStyleType: "disc",
                  }}
                >
                  {workOrder}
                </li>
              ))}
            </ul>
          )}
          {/* {durationText && (
            <Typography.Text
              type="secondary"
              style={{ fontSize: "0.8em", lineHeight: 1.2 }}
            >
              {durationText}
            </Typography.Text>
          )} */}
        </>
      )}
    </div>
  );
}
